import {useState, useEffect} from "react";

// API
import {GetSeries} from "../../../../Api/Series";

// Models
import SeriesDTO from "../../../../Models/DTOs/SeriesDTO";

function useFetchSeriesDetails(
    seriesId: number | undefined,
    refresh: number
) {
    const

        [series, setSeries] = useState<SeriesDTO>({} as SeriesDTO),
        [loading, setLoading] = useState<boolean>(false),
        [error, setError] = useState<string>("");

    useEffect(() => {
        let isCancelled = false;
        const controller = new AbortController();

        if (seriesId) {
            setLoading(true);

            (async () => {
                try {
                    const seriesData = await GetSeries(seriesId, controller);
                    if (!isCancelled) {
                        setSeries(seriesData);
                    }
                } catch (err) {
                    if (!isCancelled) {
                        setError("Failed to fetch series details.");
                        console.error(err);
                    }
                } finally {
                    if (!isCancelled) {
                        setLoading(false);
                    }
                }
            })();
        }

        return () => {
            isCancelled = true;
            controller.abort();
        };
    }, [seriesId, refresh]);

    return {series, loading, error};
}

export default useFetchSeriesDetails;
